import { createSelector } from 'reselect'
import { computeHeightBound, cameraHeightGreaterThanComputed,
  computeDistanceDisplay, computeAngle, computeCameraPxHeight,
  computeSceneHeightLabelHeight } from './helpers'
import { cameraPropSelector } from 'selectors/components'

export const computedHeightBoundSelector = createSelector(
  cameraPropSelector('distance'),
  computeHeightBound
)

export const cameraHeightGreaterThanComputedSelector = createSelector(
  cameraPropSelector('cameraHeight'),
  cameraPropSelector('distance'),
  cameraHeightGreaterThanComputed
)

export const distanceDisplaySelector = createSelector(
  cameraPropSelector('cameraHeight'),
  cameraPropSelector('distance'),
  computeDistanceDisplay
)

export const isImperialSelector = state => state.ui.isImperial

export const unitSelector = createSelector(
  isImperialSelector,
  isImperial => isImperial ? 'ft' : 'm'
)

export const angleSelector = createSelector(
  cameraPropSelector('fovMode'),
  cameraPropSelector('verticalAngleOfView'),
  cameraPropSelector('horizontalAngleOfView'),
  computeAngle
)

export const otherAngleSelector = createSelector(
  cameraPropSelector('fovMode'),
  cameraPropSelector('horizontalAngleOfView'),
  cameraPropSelector('verticalAngleOfView'),
  computeAngle
)

export const resolutionSelector = createSelector(
  cameraPropSelector('fovMode'),
  cameraPropSelector('horizontalResolution'),
  cameraPropSelector('verticalResolution'),
  computeAngle
)

export const convertedDistanceSelector = createSelector(
  cameraPropSelector('distance'),
  isImperialSelector,
  (value, isImperial) => value * (isImperial ? 0.3048 : 1)
)

export const cameraPxHeightSelector = createSelector(
  cameraPropSelector('cameraHeight'),
  cameraPropSelector('distance'),
  computedHeightBoundSelector,
  computeCameraPxHeight
)

export const sceneHeightLabelPxHeightSelector = createSelector(
  cameraPropSelector('sceneHeight'),
  cameraPropSelector('cameraHeight'),
  cameraPropSelector('distance'),
  computeSceneHeightLabelHeight,
  computeCameraPxHeight
)



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/selectors.js